module.exports = __webpack_public_path__ + "img/altitude-room-1.0ada93ab.jpg";